import React from "react";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import BannerCreateForm from "./BannerCreateForm";
import { BANNER_FORM_TEXTS } from "../shared/constants";
import { PageContentBox } from "../shared/styledComponents";

const CreateBannerPage: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PageLayout showSearch={false}>
      <PageContentBox>
        <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" color="text.primary" mb={2}>
          {BANNER_FORM_TEXTS.createPageTitle}
        </Typography>
        <BannerCreateForm />
      </PageContentBox>
    </PageLayout>
  );
};

export default CreateBannerPage;
